(() => {
  const anchor = document.currentScript?.dataset.appSectionAnchor;
  const target = anchor && document.getElementById(anchor);
  if (!target || window.location.hash !== '#' + anchor) return;

  let active = true;
  let frame = 0;
  const align = () => {
    frame = 0;
    if (active) target.scrollIntoView({block: 'start', behavior: 'instant'});
  };
  const schedule = () => {
    if (active && !frame) frame = window.requestAnimationFrame(align);
  };
  const observer = new ResizeObserver(schedule);
  const stop = () => {
    active = false;
    observer.disconnect();
    window.cancelAnimationFrame(frame);
    window.removeEventListener('load', schedule);
    ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(event => window.removeEventListener(event, stop));
  };
  observer.observe(document.body);
  observer.observe(target);
  window.addEventListener('load', schedule, {once: true});
  ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(event => window.addEventListener(event, stop, {passive: true}));
  window.setTimeout(stop, 10000);
  schedule();
})();
